import { render, staticRenderFns } from "./LogistSelect.vue?vue&type=template&id=5e31f50e"
import script from "./LogistSelect.vue?vue&type=script&lang=js"
export * from "./LogistSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports